import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Scale } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { gbp, longDate } from "@/lib/format";

export default function PublicCriteria() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/public/criteria/${token}`).then((r) => setData(r.data)).catch((err) => setError(errorText(err)));
  }, [token]);

  return (
    <div className="min-h-screen bg-panel text-foreground">
      <header className="border-b bg-background"><div className="mx-auto flex h-14 max-w-2xl items-center px-6"><Logo /></div></header>
      <main className="mx-auto max-w-2xl px-6 py-10">
        {error && <p className="rounded-xl bg-destructive/10 p-4 text-destructive" data-testid="criteria-error">{error}</p>}
        {!data && !error && <Loader2 className="mx-auto size-6 animate-spin text-muted-foreground" />}
        {data && (
          <article className="rise" data-testid="public-criteria-page">
            <p className="text-xs font-medium text-muted-foreground">How tenants are selected</p>
            <h1 className="mt-2 text-2xl font-semibold" data-testid="criteria-address">{data.address}</h1>
            <p className="mt-2 text-base text-muted-foreground">
              {gbp(data.monthly_rent)} a month · move in {longDate(data.move_in_date)} · {data.tenants} {data.tenants === 1 ? "tenant" : "tenants"} · let by {data.agency_name}
            </p>
            <section className="mt-8 rounded-xl border bg-background p-5">
              <h2 className="text-base font-semibold">The criteria</h2>
              <ul className="mt-4 flex flex-col gap-3">
                {data.plain_english.map((line, i) => (
                  <li key={i} className="flex gap-3 text-base" data-testid={`criteria-line-${i}`}>
                    <span className="mt-2.5 size-1.5 shrink-0 rounded-full bg-foreground/40" />
                    <span className="leading-relaxed">{line}</span>
                  </li>
                ))}
              </ul>
            </section>
            <section className="mt-4 rounded-xl bg-brand/40 p-5 dark:bg-brand/10" data-testid="criteria-fair">
              <h2 className="flex items-center gap-2 text-base font-semibold"><Scale className="size-4" /> Fair by design</h2>
              <p className="mt-2 text-base leading-relaxed">
                Documents are checked by fixed rules, not by a person's impression. The agent first sees a blind summary with no name, photo, age, nationality, household or income source.
              </p>
            </section>
            <p className="mt-6 font-mono text-xs text-muted-foreground" data-testid="criteria-version">
              Criteria version {data.criteria_version} · published {longDate(data.published_at)}
            </p>
          </article>
        )}
      </main>
    </div>
  );
}
